import React, { useState, useEffect } from 'react';
import { Heart, Gift, ExternalLink, AlertCircle, Mail } from 'lucide-react';

const BabyRegistry = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reservingItem, setReservingItem] = useState(null);

  const SHEET_URL = 'https://docs.google.com/spreadsheets/d/17w6cJIpH1DX-seOS1Eqsr8U2dSmgzxVKlEEY3kH6ptA/export?format=csv&gid=0';
  const DESTINATION_EMAIL = 'f2dde563672cf28084cb95e148b7aa36'; //'eugi90@gmail.com';
  const FORMSUBMIT_URL = `https://formsubmit.co/ajax/${DESTINATION_EMAIL}`;
  const AMAZON_LIST_URL = 'https://www.amazon.it/baby-reg/eugenio-nurrito-febbraio-2026-novidimodena/1Y3SXKS7USECQ'; // TODO: Fill with actual Amazon list URL

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Verifica se l'URL del foglio è configurato
      if (SHEET_URL === 'YOUR_GOOGLE_SHEETS_CSV_URL_HERE') {
        // Usa dati di esempio se non è configurato
        setItems([
          {
            id: 1,
            nome: 'Passeggino Trio Chicco',
            link: 'https://example.com/passeggino',
            descrizione: 'Passeggino trio completo con navicella, ovetto e seggiolino auto',
            image: null
          },
          {
            id: 2,
            nome: 'Set Lenzuola Lettino',
            link: 'https://example.com/lenzuola',
            descrizione: 'Set completo di lenzuola per il lettino, in cotone biologico',
            image: null
          }
        ]);
        setLoading(false);
        return;
      }
      
      // Carica i dati reali da Google Sheets
      const response = await fetch(SHEET_URL);
      
      if (!response.ok) {
        throw new Error('Impossibile caricare il foglio Google. Verifica che sia pubblico e che l\'URL sia corretto.');
      }
      
      const csv = await response.text();
      const parsed = parseCSV(csv);
      
      if (parsed.length === 0) {
        throw new Error('Il foglio Google sembra essere vuoto.');
      }
      
      setItems(parsed);
      setLoading(false);
      
    } catch (err) {
      console.error('Errore caricamento:', err);
      setError(err.message || 'Errore nel caricamento della lista. Riprova tra poco.');
      setLoading(false);
    }
  };

  const parseCSV = (csv) => {
    const lines = csv.split('\n').filter(line => line.trim());
    
    if (lines.length < 2) {
      return [];
    }
    
    // Salta la prima riga (header)
    return lines.slice(1).map((line, index) => {
      // Parser CSV più robusto che gestisce virgolette
      const values = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          values.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }
      values.push(current.trim());
      
      return {
        id: index + 1,
        nome: values[0] || '',
        link: values[1] || '',
        descrizione: values[2] || '',
        image: values[3] || null,
      };
    }).filter(item => item.nome && item.link); // Filtra righe vuote o incomplete
  };

  const handleReserve = async (item) => {
    const nome = prompt('Come ti chiami?');
    if (!nome) {
      return;
    }
    
    const contatto = prompt('Lascia la tua email o il tuo numero di telefono (per essere sicuri di non fare doppioni!)');
    if (!contatto) {
      return;
    }

    setReservingItem(item.id);
    
    try {
      const response = await fetch(FORMSUBMIT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          prodotto: item.nome,
          link: item.link,
          chi: nome,
          contatto: contatto,
          _subject: `Nuovo regalo da ${nome}: ${item.nome}!`,
          _captcha: 'false',
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      alert(`Grazie ${nome}! Abbiamo ricevuto la tua prenotazione per "${item.nome}". Ti contatteremo presto! 💕`);
      
    } catch (err) {
      alert('Errore nell\'invio della prenotazione. Riprova o contattaci direttamente via email.');
    } finally {
      setReservingItem(null);
    }
  };

  const scrollToArticles = () => {
    const element = document.getElementById('articoli-singoli');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF0DD] via-[#FFF0DD] to-[#D1D3D4]">
      <div className="bg-white shadow-sm border-b border-[#D1D3D4]">
        <div className="max-w-4xl mx-auto px-4 py-10">
          <div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#FFF0DD] to-[#D1D3D4] rounded-full mb-6 shadow-sm">
                <Heart className="w-10 h-10 text-[#E2A16F]" fill="currentColor" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3">Lista Nascita</h1>
              <h2 className="text-3xl md:text-4xl font-bold text-[#E2A16F] mb-6">Agata</h2>
            </div>
            
            <div className="max-w-2xl mx-auto space-y-4">
              <p className="text-gray-700 text-lg leading-relaxed text-justify">
                Ciao a tutti! Siamo <span className="font-semibold text-[#E2A16F]">Eli ed Eugi</span> e tra poco arriverà la nostra piccola Agata.<br />Siamo emozionatissimi! 💕
              </p>
              <div className="text-gray-700 text-lg leading-relaxed text-justify">
                <p className="mb-2">
                  Abbiamo preparato questa lista con alcune cose che ci serviranno per accoglierla al meglio.
                </p>
                <p className="mb-3">Potete partecipare in uno di questi modi:</p>
                <div className="space-y-4 ml-2">
                  <div className="flex gap-3">
                    <span className="text-2xl flex-shrink-0">1️⃣</span>
                    <div className="flex-1">
                      <span className="font-medium">Lista Amazon:</span> acquistando un regalo dalla lista Amazon, ce lo potrete far recapitare direttamente a casa.
                      {AMAZON_LIST_URL && (
                        <div className="mt-2">
                          <a
                            href={AMAZON_LIST_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#86B0BD] hover:bg-[#6a8e9a] text-white rounded-lg transition-colors font-medium shadow-sm hover:shadow"
                          >
                            Vai alla Lista Amazon
                            <ExternalLink className="w-4 h-4" />
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="text-2xl flex-shrink-0">2️⃣</span>
                    <div className="flex-1">
                      <span className="font-medium">Articoli Singoli:</span> sono elencati qua sotto e sono acquistabili online o in negozio; per evitare doppioni, dopo l'acquisto cliccate su <span className="font-semibold">"Ho comprato questo oggetto"</span> o contattateci con un messaggio/telefonata.
                      <div className="mt-2">
                        <button
                          onClick={scrollToArticles}
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#E2A16F] hover:bg-[#d18f5e] text-white rounded-lg transition-colors font-medium shadow-sm hover:shadow"
                        >
                          Vai agli Articoli
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <span className="text-2xl flex-shrink-0">3️⃣</span>
                    <div className="flex-1">
                      <span className="font-medium">Contributo in denaro:</span> se preferite, è assolutamente benvenuto anche un contributo libero, che utilizzeremo per le sue prime necessità.
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed text-justify">
                Ogni regalo, grande o piccolo, sarà prezioso per noi e per lei. Grazie di cuore per il vostro affetto!
              </p>
              
              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-start justify-center gap-2 text-gray-600">
                  <Mail className="w-5 h-5 text-[#E2A16F]" />
                  <p className="text-sm">
                    <span className="font-medium">Dubbi o domande?</span> Contattateci direttamente, saremo felici di rispondervi!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-10">
        {loading && (
          <div className="text-center py-16">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#D1D3D4] border-t-[#E2A16F]"></div>
            <p className="mt-4 text-gray-600">Caricamento lista...</p>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-5 mb-8 flex items-start gap-3 shadow-sm">
            <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-red-800 font-medium">Errore</p>
              <p className="text-red-600 text-sm mt-1">{error}</p>
            </div>
          </div>
        )}

        {!loading && !error && items.length > 0 && (
          <div id="articoli-singoli">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex items-center justify-center w-10 h-10 bg-[#FFF0DD] rounded-lg">
                <Gift className="w-6 h-6 text-[#E2A16F]" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-800">Articoli Singoli</h3>
            </div>
            
            <div className="space-y-4">
              {items.map(item => (
                    <div 
                      key={item.id}
                      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all hover:shadow-md"
                    >
                      <div className="flex flex-row gap-4 mb-4">
                        {item.image && (
                          <div className="flex-shrink-0">
                            <img 
                              src={item.image} 
                              alt={item.nome}
                              className="w-24 h-24 object-cover rounded-lg border border-gray-200"
                            />
                          </div>
                        )}
                        <div className="flex-1">
                          <h4 className="text-xl font-semibold text-gray-800 mb-2">
                            {item.nome}
                          </h4>
                          
                          {item.descrizione && (
                            <p className="text-gray-600 leading-relaxed">
                              {item.descrizione}
                            </p>
                          )}
                        </div>
                      </div>
                        
                      <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#86B0BD] hover:bg-[#6a8e9a] text-white rounded-lg transition-colors font-medium shadow-sm hover:shadow"
                        >
                          Vedi Prodotto
                          <ExternalLink className="w-4 h-4" />
                        </a>
                        
                        <button
                          onClick={() => handleReserve(item)}
                          disabled={reservingItem === item.id}
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#E2A16F] hover:bg-[#d18f5e] disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors font-medium shadow-sm hover:shadow"
                        >
                          {reservingItem === item.id ? (
                            <>
                              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                              <span>Invio...</span>
                            </>
                          ) : (
                            <>
                              <Heart className="w-4 h-4" fill="currentColor" />
                              <span>Ho comprato questo oggetto</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
              ))}
            </div>
          </div>
        )}

        <div className="mt-16 text-center border-t border-gray-200 pt-10">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-[#FFF0DD] rounded-full mb-4">
            <Heart className="w-6 h-6 text-[#E2A16F]" fill="currentColor" />
          </div>
          <p className="text-gray-700 text-lg font-medium mb-2">
            Grazie per celebrare con noi l'arrivo di Agata!
          </p>
          <p className="text-gray-600">
            Con affetto, Eli ed Eugi 💕
          </p>
        </div>
      </div>
    </div>
  );
};

export default BabyRegistry;
